import React from 'react'
import PropTypes from 'prop-types'

import Label from '../../label'
import Loading from '../../loading/loading'

//http://stackoverflow.com/questions/28750489/upload-file-component-with-reactjs
//http://codepen.io/hartzis/pen/VvNGZP
//http://www.hartzis.me/react-image-upload/
import './upload.styl'
class FileUpload extends React.Component {

    state = {
        files:[],
        uploaded:[],
        dragActive: false
    }

    pathI18n = 'app.components.fileUpload.'

    constructor(props) {
        super(props);
        this.onDragOver = this.onDragOver.bind(this)
        this.onDragLeave = this.onDragLeave.bind(this)
        this.onDrop = this.onDrop.bind(this)
        this.send = this.send.bind(this)
    }

    onDragLeave(e) {
        this.setState({
            dragActive: false
        });
    }

    onDragOver(e) {
        e.preventDefault();
        e.dataTransfer.dropEffect = 'copy';

        this.setState({
            dragActive: true
        });
    }

    onDrop(e) {
        e.preventDefault();
        this.setState({ dragActive: false });
        let file = (e.target.files || (e.dataTransfer && e.dataTransfer.files))[0];

        this.setState({loading: true})
        let reader = new FileReader();
        // new Promise( resolve =>
        //     reader.onloadend = e => {
        //         file.content = e.target.result;
        //         this.state.files.push(file);
        //         this.setState(this.state);
        //         this.props.onDrop && this.props.onDrop(file);
        //         resolve(file)
        //     }).then(file => {
        //     this.send(file)
        //     this.setState({loading: false})
        // })
        reader.onloadend = e => {
            file.content = e.target.result;
            this.state.files.push(file);
            this.setState(this.state);
            this.props.onDrop && this.props.onDrop(file);
            this.send(file)
            this.setState({loading: false})
        }
        reader.readAsDataURL(file)
    }

    send (file) {
        let promise = this.props.upload(file)
        promise && (promise.then instanceof Function) ? promise.then(this.setState, err => console.log(err)) : this.setState();
    }

    render() {
        let { label } = this.props;
        let { loading=false } = this.state
        let dragging = this.state.dragActive ? ' dragging' : ''

        return <div className="form form-upload">
            <Label>{label}</Label>:
            <div className='form-upload-dragzone' onClick={ e => this.fileInput.click()}>
                <div className={'form-upload-files' + dragging} onDragLeave={this.onDragLeave} onDragOver={this.onDragOver} onDrop={this.onDrop}>
                    <Label>{label + '.dropzone'}</Label>
                    <input type='file' ref={node => this.fileInput = node} style={{display: 'none' }} onChange = {this.onDrop} />
                    <Loading printable={loading} />
                </div>
            </div>
        </div>
    }
}

FileUpload.propTypes = {
    label: PropTypes.string,
    upload: PropTypes.func.isRequired,
    onDrop: PropTypes.func
}

FileUpload.defaultProp = {
    disabled: false
}

export default FileUpload
